<!-- Start Breadcrumb -->
<div class="breadcrumb-area bg-cover shadow theme-hard text-center text-light" style="background-image: url(assets/img/banner/8.jpg);">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1>Terms and Conditions</h1>
        <ul class="breadcrumb">
          <li><a routerLink="/"><i class="fas fa-home"></i> Home</a></li>
          <li>Policies</li>
          <li>Terms and Conditions</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- End Breadcrumb -->

<div class="services-details-area overflow-hidden default-padding">
  <div class="container">
    <div class="services-details-items">
      <div class="row">

        <div class="col-xl-8 col-lg-7 order-lg-last pl-50 pl-md-15 pl-xs-15">
          <div class="content-style-one">
            <h2>Terms and Conditions</h2>
            <p>
              <strong>Services:</strong> Educational ERP, School & College Management Software, SaaS applications, Mobile applications, Digital services, Custom software development, Payment collection services on behalf of educational institutions.
            </p>
            <p>
              Users must provide accurate information, protect login credentials, and use services lawfully.
            </p>
            <p>
              Payments are securely processed through authorized payment gateways.
            </p>
            <p>
              All software, source code, designs, logos and trademarks remain the property of Novarix Technologies.
            </p>
            <p>
              Liability is limited to the maximum extent permitted by law.
            </p>
            <p>
              These terms are governed by the laws of India.
            </p>
            <p>
              <strong>Contact:</strong> support@novarix.tech
            </p>
          </div>
        </div>

        <div class="col-xl-4 col-lg-5 mt-md-120 mt-xs-50 services-sidebar">
          <div class="single-widget services-list-widget">
            <h4 class="widget-title">Policies</h4>
            <div class="content">
              <ul>
                <li routerLinkActive="current-item"><a routerLink="/policies/terms-and-conditions">Terms and conditions</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/privacy-policy">Privacy Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/refund-policy">Refund Policy</a></li>
                <li routerLinkActive="current-item"><a routerLink="/policies/cancellation-policy">Cancellation Policy</a></li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
